import { Button, Divider, withStyles, WithStyles, withTheme, WithTheme } from '@material-ui/core'; // Should have Button
import * as React from 'react';
import ReactPlayer from 'react-player';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
// import rsCityPoster from '../assets/press/RS_CityPoster.jpg';
import headerImage from '../assets/press/RScollageWithTitle.jpg';
// import rsMechArtGorgon from '../assets/press/rsMechArtGorgon.jpg';

import itchIoLogo from '../assets/images/logo_transparent.png';
import steamLogo from '../assets/images/steamLogo.png';

import rsAnimeOP1 from '../assets/press/rsAnimeOP1.jpg';
import rsAnimeOP2 from '../assets/press/rsAnimeOP2.jpg';
import rsAnimeOP3 from '../assets/press/rsAnimeOP3.jpg';
import rsAnimeOP4 from '../assets/press/rsAnimeOP4.jpg';
import rsAnimeOP5 from '../assets/press/rsAnimeOP5.jpg';
import rsCollageNoTitle from '../assets/press/RScollageNoTitle.jpg';
import rsCollageWithTitle from '../assets/press/RScollageWithTitle.jpg';
import rsScreenShot01 from '../assets/press/rsScreenShot01.png';
import rsScreenShot02 from '../assets/press/rsScreenShot02.png';
import rsScreenShot03 from '../assets/press/rsScreenShot03.png';
import rsScreenShot04 from '../assets/press/rsScreenShot04.png';
import rsScreenShot05 from '../assets/press/rsScreenShot05.png';
import rsScreenShot06 from '../assets/press/rsScreenShot06.png';

import rsStencilBlack from '../assets/press/rsStencilBlack.png';
import rsStencilWhite from '../assets/press/rsStencilWhite.png';
import rsStencilWhiteDropShadow from '../assets/press/rsStencilWhiteDropShadow.png';

import gameplayTrailerThumb from '../assets/press/gameplayTrailerThumb.jpg';
import launchTrailerThumb from '../assets/press/launchTrailerThumb.jpg';
import tracesThumb from '../assets/press/tracesThumb.jpg';

import audioBossTheme from '../assets/press/riskSystemBossTheme.mp3';
import audioExosphere from '../assets/press/riskSystemExosphere.mp3';
import audioOpeningTheme from '../assets/press/riskSystemOpeningTheme.mp3';
import audioSignalNoiseBeat from '../assets/press/riskSystemSignalNoiseBeat.mp3';

import musicThumbBoss from '../assets/press/musicThumbBoss.png';
import musicThumbExo from '../assets/press/musicThumbExo.png';
import musicThumbOP from '../assets/press/musicThumbOP.png';
import musicThumbSignal from '../assets/press/musicThumbSignal.png';

const styles = {

}

interface IComponentState {
    scrollPosition: number;
}

type Props = WithStyles & WithTheme;

export class Press extends React.Component<Props, IComponentState> {
    public mediaRefs: Array<React.Ref<ReactPlayer>>;
    constructor(props: Props) {
        super(props);
        this.state = {
            scrollPosition: 0            
        };
        this.mediaRefs = [];
    }

    public render() {
        const mediaUrls: any[] = [
            { media: audioBossTheme, thumb: musicThumbBoss },
            { media: audioOpeningTheme, thumb: musicThumbOP },
            { media: audioSignalNoiseBeat, thumb: musicThumbSignal },
            { media: audioExosphere, thumb: musicThumbExo },
            { media: 'https://www.youtube.com/watch?v=o9dWtsEujkA', thumb: gameplayTrailerThumb },
            { media: 'https://www.youtube.com/watch?v=4gqQXlqpGHs', thumb: launchTrailerThumb },
            { media: 'https://www.youtube.com/watch?v=77ns1S_qV_4', thumb: tracesThumb }
        ];
        return (
            <div className={'pressKit'} style={{ backgroundColor: '#F8F8F8', minWidth: '360px', width: '70%', margin: '0 auto', paddingBottom: '60px' }}>
                <img src={headerImage} style={{ width: '100%' }} />
                <Divider />
                <div className={'pressKitSection'}>
                    <h3 style={{ width: '100%' }}>DESCRIPTION</h3>
                    <p>Risk System is a gorgeous hand crafted 2D shmup with a unique core mechanic where you boost your ship's firepower by performing stunts and weaving between enemy fire. This complete cohesion between controls, gameplay and aesthetics means that when you play, you'll feel like you're a daredevil ace pilot from the most awesome mecha anime!</p>
                    <p>Risk System features multiple endings and character interactions based on player performance, mirroring the experience of the protagonist gaining mastery of their ship and using the systems of gameplay to tell a story.</p>
                    <p>Risk System was created by Newt Industries, a two-person studio with an emphasis on craft in both aesthetic and the feel of play.</p>
                </div>
                <Divider />
                <div className={'pressKitSection'} id="factsheet">
                    <h3 style={{ width: '100%' }}>FACT SHEET</h3>
                    <ul className={'bulleted'}>
                        <li><b>Developer:</b> Newt Industries, LLC; Based in Milwaukee, WI</li>
                        <li><b>Release Date:</b> May 14th, 2019 (Windows/Mac/Linux/Steam/Itch/Humble) Coming Soon to UWP/Consoles</li>
                        <li><b>Platforms:</b> Windows, MacOS, Ubuntu, UWP, Xbox One</li>
                        <li><b>Website:</b><a href="https://www.newtindustries.com"> NewtIndustries.com</a></li>
                        <li><b>Price:</b> USD 11.99 (USD 9.99 on Itch.io)</li>
                        <li><b>Availability:</b> Digital Download</li>
                        <li><b>Languages:</b> English</li>
                        <li><b>ESRB:</b> E for everyone</li>
                        <li><b>File Size:</b> ~200MB</li>
                        <li><b>Press Contact:</b> <a href="mailto:info@newtindustries.com"> info@newtindustries.com</a></li>
                        <li><b>Social:</b> <a href="https://twitter.com/risksystem_game" target="_blank">Twitter</a>, <a href="https://www.facebook.com/newtindustrieswi" target="_blank">Facebook</a>, <a href="https://www.twitch.tv/newtindustries" target="_blank">Twitch</a>, <a href="https://www.youtube.com/newtindustries" target="_blank">Youtube</a></li>
                    </ul>
                </div>
                <Divider />
                <div className={'pressKitSection'}>
                    <h3 style={{ width: '100%' }}>FEATURES</h3>
                    <ul className={'bulleted'}>
                        <li>Increase your B-Meter &amp; firepower quickly by flying as close to enemy fire as possible and absorbing their energy. The closer you fly, the more energy you net!</li>
                        <li>Fire your weapon while flying close to enemy fire and absorbing to perform powerful "Risk Shots". Enemies destroyed by these powered up shots will turn into energy to power your shield. The best defense is a risky offense!</li>
                        <li>Fly like an ace pilot and utilize Barrel Rolls to quickly cover vertical space &amp; modify your attack!</li>
                        <li>Unleash the Barrier Breaker once the B-Meter is full to inflict huge damage on everything in sight!</li>
                        <li>Playing for points is fun again as higher scores are awarded for explosive bursts of destruction and taking risks! Destroy multiple enemies at once and utilize "Risk Shots" to string together combos and increase your score multiplier!</li>
                        <li>Experience different facets and paths to the story based on your performance and actions taken during missions!</li>
                    </ul>
                </div>
                <Divider />
                <div className={'pressKitSection'}>
                    <h3 style={{ width: '100%' }}>KEY ART</h3>
                    <p>To download the full press kit assets, <a href="/risk_system_press_media.zip" target="_blank">click here.</a></p>
                    <Carousel showArrows={true}>
                        <div>
                            <img src={rsAnimeOP1} />
                            {/* <p className="legend">Anime OP Frame Alys</p> */}
                        </div>
                        <div>
                            <img src={rsAnimeOP2} />
                            {/* <p className="legend">Anime OP Frame Ashley</p> */}
                        </div>
                        <div>
                            <img src={rsAnimeOP3} />
                            {/* <p className="legend">Anime OP Frame Fal</p> */}
                        </div>
                        <div>
                            <img src={rsAnimeOP4} />
                            {/* <p className="legend">Anime OP Frame Volsh</p> */}
                        </div>
                        <div>
                            <img src={rsAnimeOP5} />
                            {/* <p className="legend">Anime OP Frame Shess</p> */}
                        </div>
                        <div>
                            <img src={rsCollageNoTitle} />
                            {/* <p className="legend">Collage No Title</p> */}
                        </div>
                        <div>
                            <img src={rsCollageWithTitle} />
                            {/* <p className="legend">Collage With Title</p> */}
                        </div>
                        <div>
                            <img src={rsScreenShot01} />
                            {/* <p className="legend">Screenshot 1</p> */}
                        </div>
                        <div>
                            <img src={rsScreenShot02} />
                            {/* <p className="legend">Screenshot 2</p> */}
                        </div>
                        <div>
                            <img src={rsScreenShot03} />
                            {/* <p className="legend">Screenshot 3</p> */}
                        </div>
                        <div>
                            <img src={rsScreenShot04} />
                            {/* <p className="legend">Screenshot 4</p> */}
                        </div>
                        <div>
                            <img src={rsScreenShot05} />
                            {/* <p className="legend">Screenshot 5</p> */}
                        </div>
                        <div>
                            <img src={rsScreenShot06} />
                            {/* <p className="legend">Screenshot 6</p> */}
                        </div>
                    </Carousel>
                </div>
                <Divider />
                <div className={'pressKitSection'}>
                    <h3 style={{ width: '100%' }}>LOGOS AND ICONS</h3>
                    <p>To download the full press kit assets (this is the same as above), <a href="/risk_system_press_media.zip" target="_blank">click here.</a></p>
                    <Carousel showArrows={true}>
                        <div style={{backgroundColor: 'white'}}>
                            <img src={rsStencilBlack} />
                            {/* <p className="legend">Logo Stencil Black</p> */}
                        </div>
                        <div>
                            <img src={rsStencilWhite} />
                            {/* <p className="legend">Logo Stencil White</p> */}
                        </div>
                        <div style={{backgroundColor: 'white'}}>
                            <img src={rsStencilWhiteDropShadow} />
                            {/* <p className="legend">Logo Stencil White Drop Shadow</p> */}
                        </div>
                       
                    </Carousel>
                </div>
                <Divider />
                <div className={'pressKitSection'}>
                    <h3 style={{ width: '100%' }}>SOUNDTRACK AND VIDEO</h3>
                    <p>To download the full press kit assets (this is the same as above), <a href="/risk_system_press_media.zip" target="_blank">click here.</a></p>
                    <Carousel onChange={this.onMediaCarouselChange}>
                        {mediaUrls.map(u => {
                            const thisRef = React.createRef<ReactPlayer>();
                            let playerWidth = '94%';
                            let playerSideMargin = '3%';
                            if (u.media.indexOf('youtube') > -1) {
                                this.mediaRefs.push(thisRef);
                                playerWidth = '90%';
                                playerSideMargin = '5%';
                            }
                            return (
                                <div key={u.media}>
                                    <img src={u.thumb} />
                                    <ReactPlayer ref={thisRef} config={{ youtube: { playerVars: { enablejsapi: true } }}} controls={true} url={u.media} style={{position: 'absolute', top: '0', left: playerSideMargin, right: playerSideMargin, bottom: '0'}} width={playerWidth} height={'100%'}/>
                                </div>
                               
                            )
                        })}
                    </Carousel>
                </div>
                <Divider />
                <div className={'pressKitSection'}>
                    <h3 style={{ width: '100%' }}>ON THE WEB</h3>
                    <div style={{ textAlign: 'center' }}>
                        <Button variant={'raised'} color={'secondary'} style={{ width: '80%', margin: '15px'}} >
                            <a href={'mailto:info@newtindustries.com?subject=PRESS KEY REQUEST'} target={'_blank'} style={{color: 'black', height: '32px', lineHeight: '32px', fontWeight: 'bold', fontSize: '16px'}}>REQUEST PRESS COPY</a>
                        </Button>
                    </div>
                    <div style={{ textAlign: 'center'}}>
                        <iframe height="50px" scrolling="no" src="https://embed.keymailer.co/g/games/80055/request_button/_a934f15f63" style={{border: 'none'}} width="200px" />
                    </div>
                    <div style={{ textAlign: 'center' }}>
						<Button variant={'raised'} color={'secondary'} style={{ width: '120px', margin: '15px'}} >
							<a href={'https://risksystem.itch.io/rs'} target={'_blank'}><img src={itchIoLogo} /></a>
						</Button>
						<Button variant={'raised'} color={'secondary'} style={{ width: '120px', margin: '25px'}} >
							<a href={'https://store.steampowered.com/app/833950/Risk_System'} target={'_blank'} style={{height: '32px'}}><img src={steamLogo} /></a>
						</Button>
						<Button variant={'raised'} color={'secondary'} style={{ width: '120px', margin: '15px'}}>
							<a href={'https://www.humblebundle.com/store/risk-system'} target={'_blank'} style={{color: 'black', height: '32px', lineHeight: '32px', fontWeight: 'bold', fontSize: '16px'}}>Humble</a>
						</Button>
                    </div>
                </div>
            </div>
        );
    }
    
    private onMediaCarouselChange = (index: number, item: React.ReactNode) => {
        const audioTags = document.getElementsByTagName('audio') as HTMLCollectionOf<HTMLAudioElement>;
        for (const audioTag of Array.from(audioTags)) {
            audioTag.pause();
        }
        if (this.mediaRefs) {
            this.mediaRefs.forEach((r: any) => {
                const innerPlayer = r.current.getInternalPlayer();
                innerPlayer.stopVideo();
            });
        }
    }
}

export default withTheme()(withStyles(styles)(Press));


// WEBPACK FOOTER //
// ./src/components/Press.tsx